"use strict";

/* GS - Carousel + collapsible benefits */
(() => {
  const BENEFITS_STORAGE_KEY = "gs_cart_benefits_open_v2";
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initCartBenefitsToggle() {
    document.querySelectorAll("[data-cdx-benefits-toggle]").forEach((details) => {
      if (details.dataset.cdxToggleReady === "1") return;

      details.dataset.cdxToggleReady = "1";

      const savedState = localStorage.getItem(BENEFITS_STORAGE_KEY);

      if (savedState === "1") {
        details.setAttribute("open", "");
      } else {
        details.removeAttribute("open");
      }

      details.addEventListener("toggle", () => {
        localStorage.setItem(BENEFITS_STORAGE_KEY, details.open ? "1" : "0");

        setTimeout(() => {
          if (window.GSInitCartDrawerEnhancements) {
            window.GSInitCartDrawerEnhancements();
          }
        }, 80);
      });
    });
  }

  function initCdxCarousel() {
    document.querySelectorAll(".cdx-carousel").forEach((root) => {
      if (root.dataset.cdxReady === "1") {
        return;
      }

      root.dataset.cdxReady = "1";

      const track = root.querySelector(".cdx-track");
      const slides = Array.from(root.querySelectorAll(".cdx-slide"));
      const inners = slides.map((slide) => slide.querySelector(".cdx-slide__inner") || slide);
      const dotsNav = root.querySelector(".cdx-dots");
      const prevBtns = Array.from(root.querySelectorAll(".cdx-prev"));
      const nextBtns = Array.from(root.querySelectorAll(".cdx-next"));

      if (!track || !slides.length || !dotsNav) return;

      const autoplayAttr = parseInt(root.dataset.autoplay || "5000", 10);
      const AUTOPLAY_MS = prefersReducedMotion ? 0 : Math.max(0, autoplayAttr);

      let index = 0;
      let timer = null;
      let hover = false;
      let startX = 0;
      let deltaX = 0;

      dotsNav.innerHTML = "";

      slides.forEach((_, i) => {
        const button = document.createElement("button");

        button.type = "button";
        button.setAttribute("aria-label", `Prikaži slajd ${i + 1}`);

        if (i === 0) {
          button.setAttribute("aria-current", "true");
        }

        button.addEventListener("click", () => {
          goTo(i, true);
        });

        dotsNav.appendChild(button);
      });

      const dots = Array.from(dotsNav.querySelectorAll("button"));

      const setHeight = () => {
        if (!inners[index]) return;

        const height = inners[index].offsetHeight;

        if (height > 0) {
          root.style.setProperty("--cdx-h", `${height}px`);
        }
      };

      const resizeObserver = new ResizeObserver(() => {
        setHeight();
      });

      const observeActive = () => {
        resizeObserver.disconnect();

        if (inners[index]) {
          resizeObserver.observe(inners[index]);
        }
      };

      const stop = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };

      const next = () => {
        goTo(index + 1);
      };

      const prev = () => {
        goTo(index - 1);
      };

      const restart = () => {
        stop();

        if (AUTOPLAY_MS > 0 && !hover) {
          timer = setInterval(next, AUTOPLAY_MS);
        }
      };

      function goTo(i, user = false) {
        index = (i + slides.length) % slides.length;

        track.style.transform = `translateX(${-index * 100}%)`;

        dots.forEach((dot, dotIndex) => {
          dot.toggleAttribute("aria-current", dotIndex === index);
        });

        slides.forEach((slide, slideIndex) => {
          slide.setAttribute("aria-hidden", slideIndex !== index);
        });

        observeActive();
        setHeight();

        if (user) {
          restart();
        }
      }

      prevBtns.forEach((button) => {
        button.addEventListener("click", () => {
          goTo(index - 1, true);
        });
      });

      nextBtns.forEach((button) => {
        button.addEventListener("click", () => {
          goTo(index + 1, true);
        });
      });

      root.addEventListener("mouseenter", () => {
        hover = true;
        stop();
      });

      root.addEventListener("mouseleave", () => {
        hover = false;
        restart();
      });

      root.addEventListener(
        "touchstart",
        (event) => {
          startX = event.touches[0].clientX;
          deltaX = 0;
          stop();
        },
        { passive: true }
      );

      root.addEventListener(
        "touchmove",
        (event) => {
          deltaX = event.touches[0].clientX - startX;
        },
        { passive: true }
      );

      root.addEventListener("touchend", () => {
        if (Math.abs(deltaX) > 40) {
          if (deltaX < 0) {
            next();
          } else {
            prev();
          }
        }

        restart();
      });

      dotsNav.addEventListener("keydown", (event) => {
        if (event.key === "ArrowRight") {
          event.preventDefault();
          next();
        }

        if (event.key === "ArrowLeft") {
          event.preventDefault();
          prev();
        }
      });

      const wrapper = root.closest("[data-cdx-benefits-toggle]");

      if (wrapper) {
        wrapper.addEventListener("toggle", () => {
          setTimeout(() => {
            setHeight();
            restart();
          }, 80);
        });
      }

      goTo(0);

      setTimeout(() => {
        setHeight();
        restart();
      }, 120);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          setHeight();
          restart();
        });
      }

      window.addEventListener("resize", () => {
        setHeight();
      });
    });
  }

  function initGsCartDrawerEnhancements() {
    initCartBenefitsToggle();
    initCdxCarousel();
  }

  document.addEventListener("DOMContentLoaded", initGsCartDrawerEnhancements);
  document.addEventListener("shopify:section:load", initGsCartDrawerEnhancements);
  document.addEventListener("cart:updated", initGsCartDrawerEnhancements);

  const observer = new MutationObserver(() => {
    initGsCartDrawerEnhancements();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.GSInitCartDrawerEnhancements = initGsCartDrawerEnhancements;
})();
